import React from 'react';
import Loadable from 'react-loadable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCommentsData } from './redux';

const LoadableComponent = Loadable({
  loader: () => import(/* webpackChunkName: 'withcomments' */ './WithComments'),
  loading: () => null,
  // timeout: 50000,
});

class WithCommentLoader extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    // this.setState({});
    if (
      !this.props.isWapView ||
      this.props.isPrime ||
      (this.props.isWapView && this.props.showCommentsOnMobile)
    ) {
      setTimeout(() => {
        this.setState({ load: true });
      }, 1000);
      document.addEventListener('load', () => {
        this.setState({ load: true });
      });
    }
  }
  render() {
    if (
      this.props.isWapView &&
      !this.props.showCommentsOnMobile &&
      this.props.msid &&
      !this.props.isPrime
    ) {
      this.props.getCommentsData({
        sortcriteria: 'AgreeCount',
        order: 'desc',
        commenttype: 'agree',
        msid: this.props.msid,
      });
      return null;
    }

    if (!this.state.load) {
      return null;
    }

    return <LoadableComponent {...this.props} />;
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  getCommentsData: params => {
    dispatch(getCommentsData(params));
  },
});

WithCommentLoader.propTypes = {
  isWapView: PropTypes.bool,
  msid: PropTypes.string,
  isPrime: PropTypes.bool,
  showCommentsOnMobile: PropTypes.bool,
  hideBottomComments: PropTypes.bool,
};

WithCommentLoader.defaultProps = {
  isWapView: false,
  msid: '',
  isPrime: false,
  showCommentsOnMobile: false,
  hideBottomComments: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(WithCommentLoader);
